import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sqg-tableItemSkel" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "sqg-tableItemSkel__mark" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "sqg-tableItemSkel__logo" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-image" })
], -1)
const _hoisted_4 = { class: "sqg-tableItemSkel__fields" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "loading" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "loadingTrack" }, null, -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "sqg-tableItemSkel__actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardButton = _resolveComponent("CardButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (field, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: 'field-'+index,
          class: "sqg-tableItemSkel__field"
        }, _hoisted_7))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actions, (action, index) => {
        return (_openBlock(), _createBlock(_component_CardButton, {
          disabled: "",
          key: 'action-'+index,
          text: "disabled",
          small: "",
          icon: "fas fa-file-image"
        }))
      }), 128))
    ])
  ]))
}